module.exports = __webpack_public_path__ + "img/icon-facebook.6261aba5.svg";